/* byrna-card-reviews.js — fills card review rows when Shopify metafield
   cache is zeroed/absent. Reads Yotpo's public widget API (group-aware
   bottomline; same source as the PDP star-rating block). Rows render
   server-side whenever metafields hold a real count; this only touches
   [data-bpr-fetch] shells. Self-idles once Yotpo's sync is corrected.
   App key is public by design (it ships in every Yotpo script URL in
   layout/theme.liquid). See issue #1590. */
(function () {
  'use strict';
  var APP_KEY = 'V5xoPQMeh5cvpsyL2jyG4zvDBeba9miDaKEUGrAE';
  var CACHE_PREFIX = 'bpr:';
  var CACHE_TTL_MS = 3600000;

  /* Star markup mirrors snippets/pistols_more_accessories.liquid exactly —
     full = 100% gradient, trailing stars = the 51% "half" gradient the
     server path uses for its inactive stars. Injected only into shells
     that carry a [data-bpr-stars] container (pistol PDP cards); grid
     shells have none and are unaffected. */
  var STAR_FULL = '<span class="yotpo-star"><svg class="yotpo-star-rating-icon yotpo-sr-star-full" width="16" height="16" viewBox="0 0 33 33" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg" transform="scale(1.2, 1.2)"><defs><linearGradient id="yotpo_stars_gradient_full___UID__"><stop offset="100%" stop-color="rgba(255,103,29,1)"></stop><stop offset="100%" stop-color="#FFFFFF" stop-opacity="1"></stop></linearGradient></defs><path d="M17.0919 25.4549L16.8335 25.299L16.5751 25.4549L7.39263 30.9971L9.82942 20.5516L9.89798 20.2577L9.66988 20.0601L1.55658 13.0315L12.2393 12.1252L12.5397 12.0997L12.6574 11.8221L16.8335 1.9688L21.0096 11.8221L21.1273 12.0997L21.4277 12.1252L32.1104 13.0315L23.9971 20.0601L23.769 20.2577L23.8376 20.5516L26.2744 30.9971L17.0919 25.4549Z" stroke="rgba(255,103,29,1)" fill="url(#yotpo_stars_gradient_full___UID__)"></path></svg></span>';
  var STAR_HALF = '<span class="yotpo-star inactive"><svg class="yotpo-star-rating-icon yotpo-sr-star-half" width="16" height="16" viewBox="0 0 33 33" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg" transform="scale(1.2, 1.2)"><defs><linearGradient id="yotpo_stars_gradient_half___UID__"><stop offset="51%" stop-color="rgba(255,103,29,1)"></stop><stop offset="51%" stop-color="#FFFFFF" stop-opacity="1"></stop></linearGradient></defs><path d="M17.0919 25.4549L16.8335 25.299L16.5751 25.4549L7.39263 30.9971L9.82942 20.5516L9.89798 20.2577L9.66988 20.0601L1.55658 13.0315L12.2393 12.1252L12.5397 12.0997L12.6574 11.8221L16.8335 1.9688L21.0096 11.8221L21.1273 12.0997L21.4277 12.1252L32.1104 13.0315L23.9971 20.0601L23.769 20.2577L23.8376 20.5516L26.2744 30.9971L17.0919 25.4549Z" stroke="rgba(255,103,29,1)" fill="url(#yotpo_stars_gradient_half___UID__)"></path></svg></span>';
  var uidSeq = 0;

  function readCache(pid) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + pid);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (Date.now() - obj.t > CACHE_TTL_MS) return null;
      return obj;
    } catch (e) { return null; }
  }

  function writeCache(pid, score, total) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + pid,
        JSON.stringify({ t: Date.now(), s: score, n: total }));
    } catch (e) { /* storage full/blocked — skip caching */ }
  }

  function fill(el, score, total) {
    if (!total || total < 1 || !score || score <= 0) return;
    var scoreEl = el.querySelector('.byrna-review-score');
    var countEl = el.querySelector('.byrna-review-count');
    if (scoreEl) scoreEl.textContent = (Math.round(score * 10) / 10).toFixed(1);
    if (countEl) countEl.textContent = total + ' reviews';
    var starsEl = el.querySelector('[data-bpr-stars]');
    if (starsEl) {
      var full = Math.floor(score);
      if (full > 5) full = 5;
      var uid = ++uidSeq;
      var starsHtml = '';
      for (var j = 0; j < 5; j++) {
        var tpl = (j < full ? STAR_FULL : STAR_HALF);
        starsHtml += tpl.split('__UID__').join('bpr_' + uid + '_' + j) + ' ';
      }
      starsEl.innerHTML = starsHtml;
    }
    el.removeAttribute('hidden');
  }

  function hydrate(el) {
    if (el.hasAttribute('data-bpr-done')) return;
    el.setAttribute('data-bpr-done', '');
    var pid = el.getAttribute('data-bpr-pid');
    if (!pid) return;
    var cached = readCache(pid);
    if (cached) { fill(el, cached.s, cached.n); return; }
    fetch('https://api-cdn.yotpo.com/v1/widget/' + APP_KEY +
          '/products/' + encodeURIComponent(pid) + '/reviews.json?per_page=1')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var b = data && data.response && data.response.bottomline;
        if (!b) return;
        writeCache(pid, b.average_score, b.total_review);
        fill(el, b.average_score, b.total_review);
      })
      .catch(function () { /* network/API failure — row stays hidden */ });
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('[data-bpr-fetch]:not([data-bpr-done])');
    for (var i = 0; i < nodes.length; i++) hydrate(nodes[i]);
  }

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; scan(document); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  /* Pill clicks and sidebar filters replace the grid innerHTML wholesale
     (delegated-handler gotcha, see facet-taxonomy.md) — re-scan on mutation. */
  new MutationObserver(scheduleScan)
    .observe(document.body, { childList: true, subtree: true });
})();
